// axios
import axios from 'axios';
import dotenv from 'dotenv';

dotenv.config();

export default axios.create({
  baseURL : process.env.VUE_APP_ROOT_API,
  timeout : 10000
})
